<template>
	<div id="app">
		<router-view/>
	</div>
</template>
<script>
export default {
  	name: 'App'
}
</script>
<style>
* {
    padding: 0;
    margin: 0;
}
#app{
	font-family: "Microsoft YaHei","微软雅黑","Microsoft JhengHei","华文细黑","STHeiti","MingLiu";
}
</style>



// WEBPACK FOOTER //
// src/App.vue